import { render } from "./PaymentSuccess.vue?vue&type=template&id=3eb407f9"
import script from "./PaymentSuccess.vue?vue&type=script&lang=js"
export * from "./PaymentSuccess.vue?vue&type=script&lang=js"

import "./PaymentSuccess.vue?vue&type=style&index=0&id=3eb407f9&lang=css"

import exportComponent from "D:\\react js\\VET_VUE\\VET-mini-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__